module.exports = __webpack_public_path__ + "img/body-shaming.1d15b905.png";